import { Media } from '../Media';
import { Size } from '../Size';
import { Position } from '../Transform/Position';
import { Rotation } from '../Transform/Rotation';
import { Scale } from '../Transform/Scale';
import { GraphicElement } from './GraphicElement';
import { ImageSVG } from './ImageSVG';
export class Graduation extends ImageSVG {
    constructor(
        engine,
        content,
        pos = new Position(),
        uuid = GraphicElement.generateUUID(),
        size = new Size(),
        options = {},
        scale = new Scale(),
        rotation = new Rotation()
    ) {
        super(engine, content, pos, uuid, size, options, scale, rotation);
        this.type = 'Graduation';
        this.isDuplicated = false;
        this.transform.isMovable = false;
    }
    get canBeUnlocked() {
        return false;
    }
    set canBeUnlocked(canBeUnlocked) {
        this._canBeUnlocked = false;
    }
    get isLocked() {
        return true;
    }
    get canBeSelected() {
        return false;
    }
    static hydrate(data) {
        const graduation = new Graduation(
            data._engine,
            data._content,
            new Position(),
            data._uuid,
            new Size(data.originSize._width, data.originSize._height)
        );
        graduation.content = Media.fromAdress(data._content._mediaAddress);
        graduation.originalContent = Media.fromAdress(data.originalContent._mediaAddress);
        graduation.transform.resize(new Scale(data.transform._scale._scaleX, data.transform._scale._scaleY), true);
        graduation.transform.rotate(data.transform._rotation._angle, true);
        graduation.isInsideTheme = data._isInsideTheme;
        graduation.transform.groupId = data.transform.groupId;
        if (data.transform._localPos) {
            graduation.transform.localPos = new Position(data.transform._localPos._x, data.transform._localPos._y);
        } else {
            graduation.transform.moveTo(new Position(data.transform._pos._x, data.transform._pos._y), true);
        }
        graduation.options = data.options;
        graduation.visible = data.visible;
        return graduation;
    }
}
